const steamAnimation = () => {

	const steamContainer = document.querySelector('.steam-animation');

	if (!steamContainer) return;

	for (let i = 0; i < 10; i++) {

		const wisp = document.createElement('span');

		wisp.classList.add('wisp')
		wisp.classList.add(`wisp-${i + 1}`)

		steamContainer.appendChild(wisp);

	}

};

export { steamAnimation };
